/** Routes du module — propriétaire : Agent A4 — Devis (admin). */
import type { RouteObject } from 'react-router';
import { FileSignature } from 'lucide-react';
import type { EntreeNav } from '../../../app/navigation';
import { RequirePermission } from '../../../shared/auth/session';
import { DetailDevisAdmin, FileDevis } from './Devis';

export const routesAdminDevis: RouteObject[] = [
  { path: 'devis', element: <RequirePermission permission="devis.lire"><FileDevis /></RequirePermission> },
  { path: 'devis/:devisId', element: <RequirePermission permission="devis.lire"><DetailDevisAdmin /></RequirePermission> },
];

export const navAdminDevis: EntreeNav[] = [
  { libelle: 'Devis', vers: '/admin/devis', permission: 'devis.lire', icone: FileSignature, groupe: 'Commercial' },
];
